import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';

import TiptapEditor from "@/components/editor/TiptapEditor.vue";

import { CustomerDictionary } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'TNC',
  setup(__props) {

const store = useStore();

const customerdictionary = computed(() => store.getters['customerdictionary/current'] as CustomerDictionary);
const tnc = computed(() => store.getters['customerdictionary/tnc'] as string);

const content = computed({
  get: () => tnc.value,
  set: (value: string) => {
    store.dispatch('customerdictionary/setTNC', value);
  }
});

const update = (value: string) => {
  store.dispatch('customerdictionary/setTNC', value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(TiptapEditor, {
      key: customerdictionary.value.company_name,
      content: content.value,
      onUpdate: _cache[0] || (_cache[0] = ($event: any) => (update($event)))
    }, null, 8, ["content"]))
  ]))
}
}

})